/**
 * Status calculation utilities
 */

/**
 * Get the status of a store based on its validation results
 * @param {Object} store - Store object with validationResults
 * @returns {string} - Status: 'clean', 'error', or 'pending'
 */
export const getStoreStatus = (store) => {
    if (store.validationResults) {
        // Check if validation is stale (>7 days old)
        if (store.validationResults.isStale === true) {
            return 'pending';
        }

        // Use score-based status for fresh validations
        const score = store.validationResults.overallScore;
        if (score >= 80) return 'clean';
        return 'error';
    }
    return 'pending';
};

/**
 * Get counts of stores by status
 * @param {Array} stores - Array of store objects
 * @returns {Object} - Object with clean, error, and pending counts
 */
export const getStatusCounts = (stores) => {
    const counts = { clean: 0, error: 0, pending: 0 };
    stores.forEach(store => {
        if (store.pages.length === 0) return;
        const status = getStoreStatus(store);
        counts[status]++;
    });
    return counts;
};
